import useSWR from 'swr';

import { useUserProfile } from '@/states/user-profile';
import { getCaseImageLayerList, getCaseImagesData } from '@/api/cases';

export const useInsightsImages = ({ caseId }: { caseId?: string }) => {
  const { profile } = useUserProfile();
  const isAllowed =
    profile?.role === 'vitaziadmin' ||
    profile?.role === 'optometrist' ||
    profile?.role === 'sandbox';

  // fetch the list of layer images
  const { data: layerListResponse, isLoading: isLoadingLayers } = useSWR(
    caseId && isAllowed ? ['layer-images-list', caseId] : null,
    ([, caseId]) => getCaseImageLayerList(caseId),
    {
      revalidateOnFocus: false,
      // avoid to retry on 404 errors, as it means the case does not have layer images
      shouldRetryOnError: (err) => {
        if (err && typeof err === 'object' && err !== null) {
          const status = (err as { status?: number }).status;
          if (status === 404) return false;
        }
        return true;
      },
    }
  );

  const { data: segmentationData, isLoading: isLoadingSegmentationData } = useSWR(
    caseId && isAllowed ? ['image-segmentation-data', caseId] : null,
    ([, caseId]) => getCaseImagesData(caseId),
    { revalidateOnFocus: false }
  );

  const layerImages = layerListResponse?.data;

  return {
    layerImages,
    segmentationData,
    loading: isLoadingLayers || isLoadingSegmentationData,
  };
};
